/**
 * Detect if the check ID is in the current URL
 *
 * @returns string || null
 */
export default function detectCurrentCheckId() {
    const match = window.location.pathname.match(/\/(?:checks\/)?(?<checkId>[\w\-]+)(?:\/start)?/);
    return match?.groups?.checkId;
}
/**
 * Detect if the check ID and page type are in the current URL
 * Used for hosted strategy routing (e.g., /checkId/faq)
 *
 * @returns {checkId: string | null, page: string | null}
 */
export function detectCurrentCheckIdAndPage() {
    const match = window.location.pathname.match(/\/(?:checks\/)?(?<checkId>[\w\-]+)(?:\/(?<page>faq|start))?/);
    return {
        checkId: match?.groups?.checkId || null,
        page: match?.groups?.page || null
    };
}
